import { useTheme } from "@mui/material/styles";
import MuiSelect, {
  SelectProps as MuiSelectProps,
  SelectChangeEvent as MuiSelectChangeEvent
} from "@mui/material/Select";

export type SelectProps = MuiSelectProps;

export type SelectChangeEvent<T> = MuiSelectChangeEvent<T>;

const Select: React.FC<SelectProps> = ({ size = "medium", ...props }) => {
  const theme = useTheme();

  return (
    <MuiSelect
      size={size}
      {...props}
      sx={{
        "&.MuiOutlinedInput-root": {
          fontSize: "16px",
          background: theme.palette.other.filledInputBackground
        },
        "&.MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
          height: "30.75px",
          lineHeight: "22.75px",
          fontSize: "13px",
          "& .MuiSelect-select": {
            paddingTop: "4px",
            paddingBottom: "4px"
          }
        }
      }}
    >
      {props.children}
    </MuiSelect>
  );
};

export default Select;
